export default "__VITE_ASSET__BdzQGtBc__"